const documentTitle = 'Versitails - ';
const reload = () => location.reload();

export { documentTitle, reload };
